import { MILLI_IN_MIN } from '@cp/src/utils/DateHelper';
import { HIERARCHY_OPTIONS } from './components/Filters/constants';

export enum QueryParamTypeMapping {
  AGENCY_DETAILS_TABLE = 'agencyDetailsTable',
  AGENT_PERFORMANCE_TABLE = 'agentPerformanceTable',
  DPD_BUCKET_TABLE = 'dpdBucketTable',
  FIELD_GOVERNANCE_TAB = 'fieldGovernanceTab',
  TELE_GOVERNANCE_TAB = 'teleGovernanceTab',
  EXTERNAL_SENSEI = 'externalSensei',
  AGENT_PERFORMANCE_TL_TABLE = 'agentPerformanceTlTable',
  AGENCY_MANAGER_PERFORMANCE_TABLE = 'agencyManagerPerformanceTable',
  AGENCY_PERFORMANCE_TABLE = 'agencyPerformanceTable',
  CCM_RM_OVERALL_PERFORMANCE_TAB = 'ccmRmOverallPerformanceTab',
  ALLOCATION_VIEW = 'allocationView',
  ACHIEVEMENT_MOVEMENT_TABLE = 'achievementMovementTable',
  GENUINE_COVERAGE_TABLE = 'genuineCoverageTable'
}
export interface IDefaultTableParams {
  pageNumber: string;
  pageSize: string;
}

export const defaultCCMRMOverallPerformanceTables: IDefaultTableParams = {
  pageNumber: '1',
  pageSize: '5'
};

export const tableNameMapping = {
  GenuineCoverageTable: 'Genuine coverage',
  AchievementMovementTable: 'Achievement movement'
};

export const filterTypeMapping = {
  agencyCode: 'agencyCode',
  stateName: 'stateName',
  dpdBucket: 'dpdBucket',
  aggregationLevel: 'aggregationLevel',
  aggregationLevelTwo: 'aggregationLevelTwo',
  aggregationLevelThree: 'aggregationLevelThree',
  dpdBuckets: 'dpdBuckets'
};

export const filterTitle = {
  agency: 'Agency',
  agencyName: 'Select agency',
  state: 'Select state',
  selectDpdBucket: 'Select DPD Buckets',
  dpdBucket: 'DPD Buckets'
};

export enum TabsKey {
  OVERALL_PERFORMANCE = 'overall_performance',
  FIELD_GOVERNANCE = 'field_governance',
  TELE_GOVERNANCE = 'tele_governance',
  DAILY_PLANNING = 'daily_planning',
  LIVE_LOCATION = 'live_location',
  ALLOCATION_VIEW = 'allocation_view',
  MAP_VIEW = 'map_view',
  VISIT_PLAN = 'visit_plan'
}

export const rowIndexZeroStyles = {
  fontWeight: 500,
  background: 'var(--navigation-blue-background-primary)',
  color: 'var(--blue-dark-cyan)'
};

export const alternativeColorStyles = {
  background: 'var(--ghost-white)',
  fontWeight: 'normal'
};

export const customBackgroundColour = {
  background: 'var(--navigation-blue-navigation-content-1)'
};

export const DPD_BUCKET_OPTIONS = [
  {
    label: 'DPD 31 - 60',
    value: 'DPD 31-60'
  },
  {
    label: 'DPD 61 - 90',
    value: 'DPD 61-90'
  },
  {
    label: 'DPD 91 - 180',
    value: 'DPD 91-180'
  },
  {
    label: 'DPD 180 and above',
    value: 'DPD 180+'
  }
];

export const CCMRMOverallPerformanceFiltersLabels = {
  state: 'state',
  agencyManager: 'agencyManager',
  agency: 'agency',
  dpdBucket: 'dpdBucket'
};

export const FilterKeyLabelMap = {
  [CCMRMOverallPerformanceFiltersLabels.state]: 'State',
  [CCMRMOverallPerformanceFiltersLabels.agencyManager]: 'Agency Manager',
  [CCMRMOverallPerformanceFiltersLabels.agency]: 'Agency',
  [CCMRMOverallPerformanceFiltersLabels.dpdBucket]: 'DPD bucket'
};

export const FIELD_GOVERNANCE_TABLE_HEIGHT = 646;
export const TELE_GOVERNANCE_TABLE_HEIGHT = 646;
export const DPD_BUCKET_TABLE_HEIGHT = 362.75;
export const AGENCY_MANAGER_PERFORMANCE_TABLE_HEIGHT = 436;
export const AGENCY_PERFORMANCE_TABLE_HEIGHT = 436;
export const POLLING_TIME = 30 * MILLI_IN_MIN; // 30 mins;
export const LINEAR_GRADIENT_PURPLE = 'linear-gradient(98deg, #EFF0FF 0%, var(--bg-primary) 100%)';
export const LINEAR_GRADIENT_ORANGE = 'linear-gradient(98deg, #FFF7EC 0%, var(--bg-primary) 100%)';
export const pageSizeOptions = [5, 10, 20, 50, 100];
export const OVERALL_ROW_LABEL = 'Overall';
export const DEFAULT_TOTAL_ELEMENTS = 0;
export const DEFAULT_PAGE_NUMBER = 1;
export const DEFAULT_PAGE_SIZE = 10;
export const DEFAULT_PAGE_INDEX = 0;

export const DEFAULT_PAGINATION_STATE = {
  pageIndex: 0,
  pageSize: 10
};

export const DEFAULT_HIERARCHY_FILTER = {
  label: 'Agency',
  value: HIERARCHY_OPTIONS.AGENCY
};

export enum AGENCY_DASHBOARD_TABLE_TYPE {
  ACHIEVEMENT_PERFORMANCE = 'ACHIEVEMENT_PERFORMANCE',
  GENUINE_COVERAGE = 'GENUINE_COVERAGE'
}
export const DEFAULT_DPD_BUCKETS = 'BUCKET_1,BUCKET_2,BUCKET_3';
